import React, { Component } from 'react';
import './SolicitudesComprasSinEnviar.css';
import MyButton from '../../../utils/MyButton';
import { FaArrowCircleLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';

import { FaPlus } from "react-icons/fa";
import { DataGrid } from '@mui/x-data-grid';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSolicitudesEnviadas, clearErrors } from '../../../redux/actions/dataasistencialactions';

export class SolicitudesEnviadas extends Component {

  constructor() {
    super();
    this.state = {

      errors: {},
      open: false,
      opendelete: false,
      cotizacionid: '',
      selectedFile: null,
    };

  };

  componentDidMount() {
    this.props.getSolicitudesEnviadas();
  }
  render() {
    const { solicitudes, loadingdataasistencial } = this.props.dataAsistencial;
    const { errors } = this.state;
    const { UI: { loading } } = this.props;

    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 100,
        sortable: false,
        renderCell: (params) => (
          <Link to={`/dashboard/solicitudesasistencial/solicitud/${params.row.solicitudid}`} style={{ textDecoration: 'none' }}>
            <MyButton tip="Ver Solicitud">
              <FaPlus color="#03178C" className="icon-eliminarcliente" />
            </MyButton>
          </Link>
        ),
      },
      { field: 'titulo', headerName: 'Titulo', flex: 1, minWidth: 200 },
      { field: 'area', headerName: 'Area', flex: 1, minWidth: 150 },
      { field: 'servicio', headerName: 'Servicio', flex: 1, minWidth: 150 }
    ];

    let mapeosolicitudes = !loadingdataasistencial ? (
      <Box sx={{ height: 600, width: '100%', mb: 4, background: '#fff' }}>
        <DataGrid
          rows={solicitudes || []}
          columns={columns}
          getRowId={(row) => row.solicitudid || Math.random()}
          pageSize={10}
          rowsPerPageOptions={[10, 25, 50]}
          disableSelectionOnClick
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#1976d2',
              color: '#ffffff',
              fontWeight: 'bold'
            },
            '& .MuiDataGrid-cell': {
              fontSize: '13px'
            }
          }}
        />
      </Box>
    ) : (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress size={50} color="primary" />
      </Box>
    );

    return (
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <Grid container spacing={2} alignItems="center" className="titulo_section" sx={{ mb: 2 }}>
          <Grid item xs={12} md={9} className="titulo_clientes">
            <h1 className="text-clientes" style={{ margin: 0 }}>Mis Solicitudes de Compras Enviadas</h1>
          </Grid>

          <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
            <Link to={`/dashboard/solicitudesasistencial`} style={{ textDecoration: 'none' }}>
              <MyButton tip="Volver">
                <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
              </MyButton>
            </Link>
          </Grid>
          <Grid item xs={12}>
            <hr className="clientes_separator" style={{ margin: 0 }} />
          </Grid>
        </Grid>

        <Box sx={{ mb: 4 }}>
          {mapeosolicitudes}
        </Box>
      </Box>
    )
  }
}

SolicitudesEnviadas.propTypes = {

  getSolicitudesEnviadas: PropTypes.func.isRequired,
  dataAsistencial: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,

};

const mapActionsToProps = { getSolicitudesEnviadas, clearErrors };

const mapStateToProps = (state) => ({
  dataAsistencial: state.dataAsistencial,
  UI: state.UI
})



export default connect(mapStateToProps, mapActionsToProps)(SolicitudesEnviadas);

